'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z' });

var HourglassEmpty = function HourglassEmpty(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

HourglassEmpty = (0, _pure2.default)(HourglassEmpty);
HourglassEmpty.muiName = 'SvgIcon';

exports.default = HourglassEmpty;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/HourglassEmpty.js
// module id = 2494
// module chunks = 0